import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IOrderDto } from '../core/models';
import { OrderService, ToastService } from '../core/services';
import { CommonConstants } from '../shared/constant';

@Component({
  selector: 'ic-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.scss'],
})
export class ReceiptComponent implements OnInit {
  public batchNo: string;
  public orderDetails: IOrderDto;
  public deliveryType = CommonConstants.DeliveryType;
  public paymentType = CommonConstants.PaymentType;

  constructor(
    private readonly orderService: OrderService,
    private readonly toastService: ToastService,
    private readonly route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((params) => {
      this.batchNo = params.batchNo;
    });
  }

  ngOnInit(): void {
    this.getOrderDetails();
  }

  getOrderDetails() {
    this.orderService.getOrder(this.batchNo).subscribe(
      (data) => {
        this.orderDetails = data;
      },
      (err) => {
        this.toastService.showError(err.exceptionMessage || err.message);
      }
    );
  }
}
